<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
#app {
  font-family: "\5FAE\8F6F\96C5\9ED1";
}
</style>
